import * as React from 'react';
import { connect } from 'react-redux';
import { withTranslation  } from 'react-i18next';
import * as UserModule from 'Modules/UserModule';
import * as Dictionary from 'Models/Dictionary';
import { NavLink } from 'react-router-dom';
import { history } from 'HelperFunctions/root';
import {checkApplicationStatus, getApplicationStatus} from 'Modules/TechnicalBreak/Service/TechnicalBreak.Services'

type Props = {
    history?: any;
};

type State = {
    subMenuVisible: boolean;
};

type DispatchedProps = {
    userStore: UserModule.Types.UserStore;
    userLogout: Function;
    t: Function;
};

class AccountMenu extends React.Component<Props & DispatchedProps, State> {
    private node;
    constructor(props: Props & DispatchedProps) {
        super(props);
        this.state = {
            subMenuVisible: false
        };
        this.logOut = this.logOut.bind(this);
    }
    private async logOut() {
      const res = await getApplicationStatus()

      if (checkApplicationStatus(res)) {
        window.location.reload();
        return
      }
        this.props.userLogout();
        history.push('/');
    }
    public componentDidMount() {
        document.addEventListener('click', this.handleClick, false);
    }
    public componentWillUnmount() {
        document.removeEventListener('click', this.handleClick, false);
    }
    private handleClick = e => {
        if (this.node && this.node.contains(e.target)) {
            return;
        }
        this.setState({
            subMenuVisible: false
        });
    };
    public render() {
        const { subMenuVisible } = this.state;
        const { t, userStore } = this.props;
        return (
            <div
                className="header__account"
                // onMouseEnter={() => this.setState({ subMenuVisible: true })} onMouseLeave={() => this.setState({ subMenuVisible: false })}
                onClick={() => this.setState({ subMenuVisible: !this.state.subMenuVisible })}
                ref={node => (this.node = node)}
            >
                <div>
                    <img width="20" className="header__account-img" src={'/images/icons/user.svg'} />
                </div>
                {subMenuVisible && (
                    <div className="header__account--submenu">
                        <ul className="header--list">
                            <li className="header__account--submenu_element">
                                <span className="header__account--submenu_element-inner">
                                    {userStore.user.firstName} {userStore.user.lastName}
                                </span>
                            </li>
                            {Dictionary.AccountMenu.map((element: UserModule.EnumTypes.Page, idx: number) => {
                                const currenElement = Dictionary.PageDetails.get(element);
                                return (
                                    <li key={idx} className="header__account--submenu_element header__account--submenu_element--single">
                                        {currenElement.url.length > 0 ? (
                                            <NavLink to={currenElement.url} className="header__account--submenu_element-inner">
                                                {currenElement.iconSrc && <img src={currenElement.iconSrc} title={t(currenElement.title)} alt={t(currenElement.title)} />}
                                                <span>{t(currenElement.title)}</span>
                                            </NavLink>
                                        ) : (
                                            <span className="header__account--submenu_element-inner" onClick={currenElement.title === UserModule.EnumTypes.Page.LOGOUT ? () => this.logOut() : null}>
                                                {currenElement.iconSrc && <img src={currenElement.iconSrc} title={t(currenElement.title)} alt={t(currenElement.title)} />}
                                                <span className="fake-a">{t(currenElement.title)}</span>
                                            </span>
                                        )}
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )}
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        userStore: state.userStore
    };
}

function mapDispachToProps(dispatch: any) {
    return {
        userLogout: () => dispatch(UserModule.Actions.logOutUser())
    };
}

export default withTranslation ('mainMenu')(
    connect(
        mapStateToProps,
        mapDispachToProps
    )(AccountMenu) as React.ComponentType<any>
);



// WEBPACK FOOTER //
// ./src/components/Layout/Header/Composites/AccountMenu.tsx